<div class="min-h-screen root-container">
  <div class="flex transition-all content scrollbars bg-lightBg dark:bg-darkBack900 " #content>

    <admin-sidebar />

    <div class="w-full transition-all text-darkgray dark:text-gray-50 main-content-wrapper" [ngClass]="sidebar.isCollapsed ? 'pl-0 md:pl-20' : 'pl-0 md:pl-80'">
      <div class="px-8 py-4 mx-auto max-w-7xl admin-content">
        <button class="menu-btn flex md:!hidden" (click)="sidebar.toggle()">
          <i class="fa-solid fa-bars"></i>
        </button>

        <router-outlet />
        <modals buttonPosition="center" #modals />
        <toast #toast />
      </div>
    </div>
  </div>
</div>

